import { Component, inject, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from '@sol/components/components/abstract.component';
import { NotificationService } from '@sol/components/services/notification.service';
import { LabNotificationComponent } from '../lab-notification/lab-notification.component';
import { LabNotifications } from './lab-notifications.state';

@Component({
  selector: 'lab-notifications',
  standalone: true,
  imports: [LabNotificationComponent],
  templateUrl: './lab-notifications.component.html',
  styleUrl: './lab-notifications.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class LabNotificationsComponent extends AbstractComponent<LabNotifications> {
  // Dependencies
  private readonly notificationService = inject(NotificationService);

  // Computed
  protected notifications$ = this.compute(state => state.notifications);

  constructor() {
    super(LabNotifications.of());

    this.notificationService.watch(state => this.update(s => s.withNotifications(state.notifications)));
  }

  public doAction(id: string): void {
    this.notificationService.doAction(id);
  }

  public close(id: string): void {
    this.notificationService.close(id);
  }
}
